import { Grid2, IconButton, Typography } from "@mui/material";
import React, { Fragment } from "react";
import { HandleSkeletion } from "../../../../utils/constants";
import { CustomizeSpan } from "../../style";
import { CustomDiv } from "../../../chat-bot/style";
import {
  CommonGrid2,
  CustomTooltip,
  StyledFlexColumnView,
  SubTitleTypo,
  TitleTypo,
} from "../../../common-components/StyledComponents";
import { CommonTippy, CustomAvatar } from "../../style";
import CopyIco from "../../../../assets/icons/CopyIco";
import InfoIco from "../../../../assets/icons/InfoIco";

export default function BasicInfo({
  section_1_data,
  loading,
  handleCopyClick,
  handleCopyMouseLeave,
  copied,
}) {
  return (
    <Fragment>
      <CommonGrid2
        container
        columnSpacing={{ xs: 2, sm: 2, md: 2, lg: 4, xl: 8 }}
        rowSpacing={0.1}
        justifyContent="start"
        margin="0rem 0px 0.5rem"
      >
        {section_1_data.map((item) => (
          <Grid2 item size={{ xs: 12, sm: 6, md: 3 }} padding="10px">
            {loading ? (
              <HandleSkeletion height={50} />
            ) : (
              <StyledFlexColumnView gap={"6px"}>
                <CommonTippy
                  content={item.title}
                  placement="top"
                  color={"#7F56D9"}
                  fontSize="12px"
                >
                  <TitleTypo
                    fontWeight={600}
                    color="#475467"
                    whiteSpace="nowrap"
                    overflow="hidden"
                    textOverflow="ellipsis"
                  >
                    {item.title}
                  </TitleTypo>
                </CommonTippy>
                {item.content && (
                  <CommonGrid2 display={"flex"} gap={"8px"} alignItems="center">
                    {item?.icon && (
                      <CustomAvatar
                        src={item.icon}
                        width={"22px"}
                        height="21px"
                        borderRadius="50%"
                        margin="0px 0px 4px 0px"
                      />
                    )}
                    <SubTitleTypo fontSize={"15px"}>
                      {item.content}
                    </SubTitleTypo>

                    {item.tooltipData &&
                      (() => {
                        const noTooltipNames = ["citizen", "legal resident"];
                        const isExcluded = noTooltipNames.includes(
                          item.content?.toLowerCase()
                        );
                        const isCitizenVisa =
                          item.title?.toLowerCase() ===
                          "citizenship/visa status";
                        const td = item.tooltipData;
                        const hasData =
                          td &&
                          (td.validFrom ||
                            td.validTo ||
                            td.holderCompanyName ||
                            td.visaStampedInPassport);

                        if (!isCitizenVisa || isExcluded || !hasData)
                          return null;

                        return (
                          <CustomTooltip
                            backgroundColor="#000"
                            maxWidth="300px"
                            placement="bottom-start"
                            arrow={false}
                            title={
                              <CustomDiv>
                                <Grid2 container spacing={2} width="260px">
                                  {(td.validFrom || td.validTo) && (
                                    <>
                                      {td.validFrom && (
                                        <Grid2 size={6}>
                                          <Typography
                                            variant="subtitle2"
                                            color="#D0D5DD"
                                          >
                                            Valid From
                                          </Typography>
                                          <Typography
                                            variant="subtitle2"
                                            fontWeight={700}
                                            color="#fff"
                                          >
                                            {td.validFrom}
                                          </Typography>
                                        </Grid2>
                                      )}
                                      {td.validTo && (
                                        <Grid2 size={6}>
                                          <Typography
                                            variant="subtitle2"
                                            color="#D0D5DD"
                                          >
                                            Valid To
                                          </Typography>
                                          <Typography
                                            variant="subtitle2"
                                            fontWeight={700}
                                            color="#fff"
                                          >
                                            {td.validTo}
                                          </Typography>
                                        </Grid2>
                                      )}
                                    </>
                                  )}
                                  {td.holderCompanyName && (
                                    <Grid2 size={6}>
                                      <Typography
                                        variant="subtitle2"
                                        color="#D0D5DD"
                                      >
                                        Holder Company name
                                      </Typography>
                                      <Typography
                                        variant="subtitle2"
                                        fontWeight={700}
                                        color="#fff"
                                      >
                                        {td.holderCompanyName}
                                      </Typography>
                                    </Grid2>
                                  )}
                                  {td.visaStampedInPassport && (
                                    <Grid2 size={6}>
                                      <Typography
                                        variant="subtitle2"
                                        color="#D0D5DD"
                                        sx={{
                                          whiteSpace: "normal",
                                          wordBreak: "break-word",
                                        }}
                                      >
                                        Visa Stamped in Passport
                                      </Typography>
                                      <Typography
                                        variant="subtitle2"
                                        fontWeight={700}
                                        color="#fff"
                                      >
                                        {td.visaStampedInPassport}
                                      </Typography>
                                    </Grid2>
                                  )}
                                </Grid2>
                              </CustomDiv>
                            }
                          >
                            <CustomizeSpan cursor="pointer" display="flex">
                              <InfoIco />
                            </CustomizeSpan>
                          </CustomTooltip>
                        );
                      })()}
                  </CommonGrid2>
                )}
                {item?.contentKey &&
                  item?.contentKey?.length !== 0 &&
                  item?.contentKey?.map((year) => (
                    <CommonGrid2
                      display={"flex"}
                      justifyContent={"space-between"}
                      gap={"4px"}
                    >
                      <CommonTippy
                        content={
                          year.industry ||
                          year.occupational_classification ||
                          year.country
                        }
                        placement="top"
                        color={"#7F56D9"}
                        fontSize="11px"
                      >
                        <CommonGrid2
                          display={"flex"}
                          justifyContent={"space-between"}
                          gap={"6px"}
                        >
                          {year?.flag && (
                            <CustomAvatar
                              src={year.flag}
                              width={"22px"}
                              height="21px"
                              borderRadius="50%"
                              margin="0px 0px 4px 0px"
                            />
                          )}
                          <SubTitleTypo
                            fontSize="15px"
                            whiteSpace="nowrap"
                            overflow="hidden"
                            textOverflow="ellipsis"
                          >
                            {year.industry ||
                              year.occupational_classification ||
                              year.country}
                          </SubTitleTypo>
                        </CommonGrid2>
                      </CommonTippy>
                      <SubTitleTypo
                        fontSize="15px"
                        color="#8396A8"
                        whiteSpace="pre"
                      >
                        {year.duration_in_years} yrs
                      </SubTitleTypo>
                    </CommonGrid2>
                  ))}
                {item.isLink && (
                  <SubTitleTypo fontSize={"15px"}>{item.isLink}</SubTitleTypo>
                )}
                {item.name && (
                  <SubTitleTypo fontSize={"14px"}>{item.name}</SubTitleTypo>
                )}
                {item.copyContent && (
                  <CommonGrid2 display={"flex"} gap={"8px"}>
                    <TitleTypo
                      fontWeight={600}
                      color="#7F56D9"
                      whiteSpace="nowrap"
                      overflow="hidden"
                      textOverflow="ellipsis"
                    >
                      {item.copyContent}
                    </TitleTypo>
                    <CustomTooltip
                      arrow
                      placement="top"
                      title={copied ? "Copied!" : "Copy to Clipboard"}
                      fontSize="12px"
                      padding="5px 10px"
                      margin="0px 0px 10px !important"
                    >
                      {item.copyContent !== "-" && (
                        <IconButton
                          onClick={() => handleCopyClick(item.copyContent)}
                          style={{ padding: "0px" }}
                          onMouseLeave={handleCopyMouseLeave}
                        >
                          <CopyIco />
                        </IconButton>
                      )}
                    </CustomTooltip>
                  </CommonGrid2>
                )}
                {item.content_split && item.content_split.length !== 0 && (
                  <CommonGrid2 display={"flex"} flexWrap={"wrap"} gap={"10px"}>
                    {item.content_split.map((item) => (
                      <CommonGrid2
                        border="1px solid rgb(208, 213, 221)"
                        color="rgb(52, 64, 84)"
                        width="max-content"
                        display="flex"
                        borderRadius="5px"
                        padding="2px 8px"
                        fontWeight="500"
                      >
                        {item?.name || item?.content}
                      </CommonGrid2>
                    ))}
                  </CommonGrid2>
                )}
              </StyledFlexColumnView>
            )}
          </Grid2>
        ))}
      </CommonGrid2>
    </Fragment>
  );
}
